











































import { AuthService } from "@/common/api";
import { HTTP_STATUS_SUCCESS } from "@/common/constant";
import QErrors from "@/common/qErrors.vue";
import QNotify from "@/common/qNotify";
import { Component, Vue } from "vue-property-decorator";
// import AuthModule from "@/store/modules/auth";
import { namespace } from "vuex-class";

const auth = namespace("Auth");
@Component({
  name: "LoginComponent",
  components: {
    QErrors,
  },
})
export default class LoginComponent extends Vue {
  @auth.Action
  public updateAuthenticateStatus!: (token: string) => void;
  @auth.Action
  public updateExpiredAt!: (time: string) => void;
  @auth.Action
  public updateRole!: (role: string) => void;
  @auth.Action
  public fetchCurrentUser!: (user) => void;
  @auth.Action
  public updateToken!: (user) => void;
  @auth.Action
  public updateRefreshToken!: (user) => void;

  public loginInfo = {
    email: "",
    password: "",
  };
  public errors: {
    tokenExpired?: string[];
    loginFailed?: string[];
    [key: string]: string[] | undefined;
  } = {};

  public created() {
    if (localStorage.getItem("token_expired")) {
      this.errors.tokenExpired = ["ログインし直してください。"];
      localStorage.removeItem("token_expired");
    }
  }

  public async login(): Promise<void> {
    this.clearError("tokenExpired");
    try {
      const result = await AuthService.login(this.loginInfo);

      if (result.status == HTTP_STATUS_SUCCESS) {
        this.updateToken(result.data.token);
        localStorage.setItem("token", result.data.token);
        this.updateRefreshToken(result.data.refresh_token);
        localStorage.setItem("refresh_token", result.data.refresh_token);
        await this.fetchCurrentUser(result.data.user);

        if (result.data.user.role.name == "admin") {
          await this.$router.push({ name: "admin.account.index" });
        } else if (result.data.user.role.name == "manager") {
          await this.$router.push({ name: "admin.news.index" });
        } else {
          await this.$router.push({ name: "admin.show.index" });
        }
        QNotify.success({
          text: "ログインしました",
        });
      } else {
        this.errors = result.errors;

        QNotify.error({
          text: result.message,
        });
      }
    } catch (error) {
      if (error.status === 400) {
        this.errors.loginFailed = [error.body.message];
      } else {
        console.log(error);
      }
    }

    // await this.fetchCurrentUser(result);
    // if (result.role === ROLE_ADMIN) {
    //   this.$router.push({ name: "admin.default" });
    // } else if (result.role === ROLE_ADMIN_CUSTOMER) {
    //   this.$router.push({ name: "admin-customer.default" });
    // } else {
    //   this.$router.push({ name: "customer.default" });
    // }
  }

  public clearError(key) {
    this.errors = { ...this.errors, ...{ [key]: [] } };
  }
}
